import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { EnabledialogComponent } from '../enabledialog/enabledialog.component';
import { DisableComponent } from '../disable/disable.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GlobalserviceService } from '../globalservice.service';
import { CodepopupComponent } from '../codepopup/codepopup.component';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.css']
})
export class TableFilterComponent implements OnInit {
  main: string;
  allfilter = [];
  currentpage: number; stat;
  totalItems: number;
  p: number = 1;
  device: number = 0;
  animal: string;
  name: string;
  dev = 1;
  Userlist = [];
  Disablefn = true;
  location;
  Department;
  Location: string;
  from: string;
  todata: string;
  filterlocation: string;
  adminlocation: string;
  subadmin: any;
  admin: boolean;
  FromDate: string;
  ToDate: string;
  lableAdmin: boolean;
  OUtlable: boolean;
  siginlocat: any;
  filterloc: any;
 searchval: any;
 searchmeth: any;

  constructor(public dialog: MatDialog,private datePipe: DatePipe, private router: Router, public snackBar: MatSnackBar, route: ActivatedRoute, public globalservice: GlobalserviceService, ) { }

  ngOnInit() {

//
 //
 var Seraching = sessionStorage.getItem("search1");
 if(Seraching !== '') {
   this.searchmeth = Seraching;
   this.valuemeth(Seraching);
   console.log(Seraching);
   sessionStorage.removeItem('search1');
 }
 else {
  this.OD_userfilter();
 }

//

  //  this.OD_userfilter();
    this.stat = true;
    this.fordate();
   if(sessionStorage.page && sessionStorage.search ==""){
    this.p = sessionStorage.page;
    }else if(sessionStorage.search){
      this.p=1;
      sessionStorage.search ="";
    }
    else{
    }
    this.adminlocation = sessionStorage.getItem('adminlocation');
    this.Department = sessionStorage.getItem('depart');
    if (this.Department == 'Total OD Users') {
    this.Department = 'All Department'
    }
    else {
      this.Department == this.Department;
    }
    this.onelocation();
  }
  onChange(value, gete, data, meth) {
    sessionStorage.setItem("employeid", gete);
    sessionStorage.setItem("odID", value);
    sessionStorage.setItem("deviceid", meth);

    if (value.checked == true) {
      this.device = 1;
      this.Enable_Dialog();
    } else {
      this.device = 0;
      this.Disable_Dialog();
    }
  }

  pagechange(event) {
    this.p = event;
  }
  OD_userfilter() {
    this.main = sessionStorage.getItem('adminlocation')

    this.Location = sessionStorage.getItem('filterloc');
    this.Department = sessionStorage.getItem('depart');
    this.from = sessionStorage.getItem('Form');
    this.todata = sessionStorage.getItem('To');
   if (sessionStorage.siginType == 'a') {
      var filt = {
        "Type": sessionStorage.Typefilter,
        "Location": sessionStorage.adminlocation,
        "Department": sessionStorage.depart,
        "FromDate": sessionStorage.Form,
        "ToDate": sessionStorage.To,
      }
    } else {
      var filt = {
        "Type": sessionStorage.Typefilter,
        "Location": sessionStorage.filterloc,
        "Department": sessionStorage.depart,
        "FromDate": sessionStorage.Form,
        "ToDate": sessionStorage.To,

      }
    }
    this.globalservice.enableloader();
    this.globalservice.ODFilter(filt).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.allfilter = responsedata['Data'];
        var page = sessionStorage.page;
        delete sessionStorage.page;
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }

  codepopup(qrcode): void {
    const dialogRef = this.dialog.open(CodepopupComponent, {
      width: '150px',
      data: { animal: this.animal, qrcode: qrcode }
    });
  }
  Enable_Dialog(): void {
    const dialogRef = this.dialog.open(EnabledialogComponent, {
      width: '250px',
      data: { animal: this.animal }
    });
  }

  Disable_Dialog(): void {
    const dialogRef = this.dialog.open(DisableComponent, {
      width: '250px',
      data: { animal: this.animal }
    });
  }

  Route_Map(EmplyId, data) {
    if(!this.searchmeth){
      this.searchval = '';
    }
    else{
      this.searchval = this.searchmeth;
    }
    sessionStorage.setItem("search1", this.searchval);
    sessionStorage.page = this.p;
    sessionStorage.setItem("getID", EmplyId);
    sessionStorage.setItem("odID", data);
    this.router.navigate(['dashboard/Filter_map']);
  }
  valuemeth(data) {
    sessionStorage.setItem("search", data);
    if (sessionStorage.siginType == 'a') {
      var metho = {
        "Name": data,
        "Type": sessionStorage.Typefilter,
        "Location": sessionStorage.adminlocation,
        "Department": sessionStorage.depart,
        "FromDate": sessionStorage.Form,
        "ToDate": sessionStorage.To,

      }
    } else {
      var metho = {
        "Name": data,
        "Type": sessionStorage.Typefilter,
        "Location": sessionStorage.filterloc,
        "Department": sessionStorage.depart,
        "FromDate": sessionStorage.Form,
        "ToDate": sessionStorage.To,
      }
    }
    this.globalservice.enableloader();
    this.globalservice.localsearch(metho).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.allfilter = responsedata['Data'];
     }
      else {
        this.OD_userfilter();
      }
     },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  backward_map() {
   if (sessionStorage.siginType == 'a') {
      this.router.navigate(['/dashboard/mainpanel_SubAdmin']);
    }
    else {
      this.router.navigate(['dashboard/OD_User']);
      this.filterloc=sessionStorage.filterloc;
    }
  }

  onelocation() {
    if (sessionStorage.siginType == 'a') {
      this.subadmin = true;
      this.admin = false;
    } else {
      this.subadmin = false;
      this.admin = true
    }
  }
  fordate(){
    if(sessionStorage.Typefilter=='4'){
        this.lableAdmin= true;
        this.OUtlable=false;
    }else{
      this.lableAdmin=false;
      this.OUtlable=true;
    }
  }
}



